import HeadTag from "@/component/SeoTags/HeadTag";
// import SVG from "react-inlinesvg";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import AdSlot728x90 from "@/component/Ads/AdSlot728x90";
import AdSlot300x250 from "@/component/Ads/AdSlot300x250";
import { useRouter } from "next/router";
// import { FiArrowRightCircle } from "react-icons/fi";
import { useWindowSize } from "@/hooks/useIsMobile";

import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";
const List1 = dynamic(() => import("@/component/Listing/List1"));
const List2 = dynamic(() => import("@/component/Listing/List2"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
import GTMScript from "@/component/Ads/GTMScript";

const NoData = dynamic(() => import("@/component/NoData"));

const FAQPageSchema = dynamic(
  () => import("@/component/SeoTags/FAQPageSchema")
);

const RegionalsElectionResultsComponent = dynamic(
  () => import("@/component/constituency")
);

const StateKeyCandidate = dynamic(
  () => import("@/component/stateKeyCandidate")
);

const RegionalsConstituencyResultsComponent = dynamic(
  () => import("@/component/constituency/constituencyResult")
);

const StateResultTally = dynamic(
  () => import("@/component/StateResultTally")
);

const CandidateProfile = dynamic(
  () => import("@/component/CandidateProfile")
);

// import Sponsor from "@/component/Sponsor";
// import { capitalizeWords } from "@/utils/articleHtmlSplit";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import axios from "axios";
const WebpageSchema = dynamic(
  () => import("@/component/SeoTags/WebpageSchema"),
);

const Breadcrumb = dynamic(
  () => import("@/component/Breadcrumb/ElectionBreadCrumb"),
);
const BreadcrumbSchema = dynamic(
  () => import("@/component/SeoTags/BreadcrumbSchema"),
);
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import LiveBlogCard from "@/component/constituency/LiveBlogCard";
import ElectionsTabs from "./ElectionTabs";
import StatesConstituencyLiveResult from "./StatesConstituencyLiveResult";
import ElectionMainTab from "./ElectionMainTab";
import ExitPollTally from "./ExitPollTally";

const Schedule = dynamic(() => import("@/screens/FiveStateElection/Schedule"));
const ConstituencyLinks = dynamic(
  () => import("@/component/constituency/ConstituencyLinks"),
);


const ExitPollCard = ({ exitPollData, halfwayMark }) => {


  return (
    <div className=" w-full   md:w-[300px] mt-3 mb-3">
      {/* Heading */}
      <div className="px-2 py-2 bg-[#96288B] text-white rounded-lg text-lg text-center mb-2">
        Axis My India
      </div>

      <div className="relative">
        {/* Halfway label */}
        <p className="text-center text-sm mb-2 relative  bg-white">
          {halfwayMark} - Halfway Mark
        </p>

        {/* Dashed center line */}
        <div className="absolute left-1/2 top-[32px] bottom-0 border-l border-dashed border-gray-400 -translate-x-1/2"></div>

        {exitPollData.map((party, index) => (
          <div
            key={index}
            className={index !== exitPollData.length - 1 ? "mb-4" : ""}
          >
            <div className="flex items-center justify-between pb-1">
              <div className="flex items-center gap-2">
                <img
                  className="w-[30px] h-[30px] rounded-full"
                  src={party.logo}
                  alt={party.name}
                />
                <span className="text-[22px] font-medium">
                  {party.name}
                </span>
              </div>

              <div className="text-[22px] font-medium">
                {party.seats}
              </div>
            </div>

            <div className="h-[15px] bg-[#e7e6e4] rounded-full">
              <div
                className="h-full rounded-full"
                style={{
                  width: party.width,
                  backgroundColor: party.color,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Index = ({
  faqData,
  electionPath = null,
  categoryNewsListData = null,
  isMobileDevice = false,
  constituencyListData = null,
  constituencyListContent = null,
  candidateData = null,
  constHindiName = null,
  constituencyDetailData = null,
  electionPassedCategory = "",
  masterKey = "",
  stateName = "",
  stateHindi = "",
  exitPollData = null,
  oldResult = {},
  oldDesc = "",
  newDesc = "",
  metaData = {},
  halfwayMark = "",
  resultKey = "",
  candidateProfileData = null,
  candidateList = null,
  liveBlogData = null,
  ConstituencyliveBlogData = null,
  staticContent = "",
  latestCandidates = [],
}) => {
  const router = useRouter();

  const [activeIndex, setActiveIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const size = useWindowSize();
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const constdetailyear = masterConfig[masterKey]?.constDetailYear;
  const constListPageMetaYear = masterConfig[masterKey]?.constListPageMetaYear;
  const haryanaLogo =
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/haryana-kiska-unit.png";
  const jharkhandLogo =
    "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/jharkhand-kiska-logo-unit.png";
  const maharashtraLogo =
    "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/maharashtra-kiska-hindi.png";
  // console.log("electionKeys", electionKeys);
  const menuList = electionKeys?.menuList;


  const [resultData, setResultData] = useState(
    electionKeys?.resultYear == 2021 ? oldResult : [],
  );

  useEffect(() => {
    let activeItemIndex = menuList.findIndex(
      (item) => item?.slug === electionPath,
    );
    if (activeItemIndex !== -1 && activeItemIndex != 0) {
      setActiveIndex(activeItemIndex);
    }
  }, []);

  const [hasMore, setHasMore] = useState(categoryNewsListData?.is_load_more == 1 ? true : false);
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  const [categoryData, setCategoryData] = useState(
    categoryNewsListData?.content,
  );


  useEffect(() => {
    setCategoryData(categoryNewsListData?.content);
  }, [categoryNewsListData?.content]);


  const currentPath = router?.asPath?.split("?")[0];
  const categoryPath = currentPath;
  const isMainElectionPath =
    currentPath === `/elections/${electionPassedCategory}`;
  const isScheduleElectionPath =
    currentPath === `/elections/${electionPassedCategory}/schedule`;
  const isKeyCandidatesPath =
    currentPath ==
    (`/elections/${electionPassedCategory}/key-candidates-list` ||
      `/elections/${electionPassedCategory}/key-candidates-list-2024`);
  const isConstituencyListPath = currentPath?.includes(
    `/elections/${electionPassedCategory}/constituency-list`,
  );
  const isElectionResultConsistPath = currentPath?.includes(
    `-assembly-constituency-result-`,
  );
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [
          currentPath.split("/")[1],
          currentPath.split("/")[2],
          currentPath.split("/")[3] ?? "",
          currentPath.split("/")[4] ?? "",
        ]
        : currentPath.split("/")[1],
    Keywords: metaData?.keywords || ["elections", "assembly chunav"],
  };
  // candidate profile page

  const path = currentPath?.toLowerCase() || "";

  const FIVE_STATES = [
    "bihar",
    "west-bengal",
    "assam",
    "tamil-nadu",
    "puducherry",
    "kerala",
  ];

  const isFiveStates = FIVE_STATES.some((state) => path.includes(state));

  // Candidate profile detection (dynamic, not hardcoded to Bihar)
  const isCandidateProfilePath =
    path.includes("/elections/assembly-chunav/") &&
    path.includes("/candidates/");

  const isFaqRoute = currentPath?.includes(`/elections/faqs`);
  const isResultRoute =
    currentPath == `/elections/${electionPassedCategory}/results`;
  const isExitPollRoute =
    currentPath === `/elections/${electionPassedCategory}/exit-result` ||
    currentPath === `/elections/${electionPassedCategory}/exit-poll`;
  // console.log("constituencyDetailData",constituencyDetailData?.constituency_name)

  const [constituencyId] = useMemo(() => {
    // const constituencyName = capitalizeWords(
    //   currentPath
    //     .split("-assembly-constituency-result-")[0]
    //     .split("/")
    //     .pop()
    //     ?.replace("-", " "),
    // );
    const constituencyId = currentPath?.split("-")?.pop();
    return [constituencyId];
  }, []);

  // candidate
  const capitalizeWords2 = (str) =>
    str
      ?.split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  const [candidateName, candidateConstiName, candidateConstituencyId] =
    useMemo(() => {
      const pathSegments = currentPath
        .split("/candidates/")[1]
        ?.split("-result-");

      // Extract candidate name
      const candidateName = capitalizeWords2(pathSegments?.[0] ?? "");

      // Extract constituency name and ID
      const constituencyParts = pathSegments?.[1]?.split("-");
      const candidateConstituencyId = constituencyParts?.slice(-2).join("-"); // Last two parts as ID

      // Remove numeric parts from the constituency name
      const candidateConstiName = capitalizeWords2(
        constituencyParts?.slice(0, -2).join("-") ?? "",
      );

      return [candidateName, candidateConstiName, candidateConstituencyId];
    }, [currentPath]);
  const constituencyName = constituencyDetailData?.constituency_name || candidateConstiName;
  // console.log("candidateName", candidateName, candidateConstiName);
  const fetchPartiesData = async () => {
    try {
      const resData = await axios.get(
        `https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyResultData.json`,
      );
      //  add switch case state wise

      let partyArr = []
      switch (stateName.toLowerCase()) {
        case "west bengal":
          partyArr = resData.data[0]["partiesDataWB"];
          break;
        case "assam":
          partyArr = resData.data[0]["partiesDataAS"];
          break;
        case "kerala":
          partyArr = resData.data[0]["partiesDataKE"];
          break;
        case "tamil nadu":
          partyArr = resData.data[0]["partiesDataTN"];
          break;
        case "puducherry":
          partyArr = resData.data[0]["partiesDataPD"];
          break;
        default:
          partyArr = [];
      }

      // console.log("the response is", partyArr);
      let tempArray = [];
      // if (partyArr.data2024 == 1) {
      // console.log('inside loop' , partyArr.data2024)
      for (let eachData of partyArr) {
        let obj = {
          partyName: eachData.partyName,
          partySeat: eachData.seatShare,
        };
        tempArray.push(obj);
      }
      // console.log('the tempAr' , tempArray);
      let finalObj = {
        partyData: tempArray,
      };
      setResultData(finalObj);

      // }
    } catch (error) {
      console.log("the error in fetching data is", error);
    }
  };
  // console.log("categoryNewsListData",categoryNewsListData)
  useEffect(() => {
    if (isResultRoute && electionKeys?.resultYear == 2026) {
      // console.log("calling fetch parties")
      fetchPartiesData();

      // Set up the interval to call the function every 20 seconds
      const interval = setInterval(fetchPartiesData, 10000);

      // Clean up the interval when the component unmounts
      return () => clearInterval(interval);
    }
  }, [isResultRoute]);
  // console.log("categoryPath",categoryPath)
  const stateCategoryPath = categoryPath?.split("/")?.slice(0, 4)?.join("/");
  // console.log("categoryPath",stateCategoryPath)
  const getMorePost = useCallback(async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    const time = Date.now();
    setLoadingSpinner(true);
    let fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getCategoryPosts?page=${currentPage}&category=${stateCategoryPath}&display=12&time=${time}`
    );

    if (fetchedData?.data?.categoryNewsListData?.content?.length > 0) {
      setCategoryData((prevData = []) => [
        ...prevData,
        ...fetchedData?.data?.categoryNewsListData?.content,
      ]);
      if (fetchedData?.data?.categoryNewsListData?.is_load_more != 1) {
        setHasMore(false);
      }
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  }, [currentPage, categoryPath]);

  useEffect(() => {
    if (currentPage < 1) {
      return;
    }
    getMorePost();
  }, [currentPage, getMorePost]);



  const [isRegionalTab, setIsRegionalTab] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0",
            )
            .addService(googletag.pubads());

          {
            document.getElementById("div-gpt-ad-1659434604998-0") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434604998-0",
                )
                .addService(googletag.pubads());
          }
          if (
            categoryNewsListData &&
            categoryNewsListData?.content?.length > 5
          ) {
            document.getElementById("div-gpt-ad-1659434785315-0") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434785315-0",
                )
                .addService(googletag.pubads());
          }
          document.getElementById("div-gpt-ad-1659435474737-0") &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0",
              )
              .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0",
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL,
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0",
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1",
            )
            .addService(googletag.pubads());
          if (
            categoryNewsListData &&
            categoryNewsListData?.content?.length >= 3
          ) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2",
              )
              .addService(googletag.pubads());
          }
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0",
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback,
      );
    }, 10);
  }, []);

  const BreadcrumbListUpdated = isMainElectionPath
    ? categoryNewsListData?.category_detail
    : isScheduleElectionPath
      ? [
        {
          id: "322111",
          title: "चुनाव",
          canonical_url: "/elections",
          amp_url: "/amp/elections",
        },
        {
          id: "322111",
          title: `${stateHindi} चुनाव`,
          canonical_url: `/elections/${electionPassedCategory}`,
          amp_url: "/amp/elections",
        },
        // {
        //   id: "322112",
        //   title: "लोकसभा चुनाव 2024",
        //   canonical_url: "/elections/${electionPassedCategory}",
        //   amp_url: "/amp/elections/${electionPassedCategory}",
        // },
        {
          id: "3221124354",
          title: "शेड्यूल",
          canonical_url: `/elections/${electionPassedCategory}/schedule`,
          amp_url: `/amp/elections/${electionPassedCategory}/schedule`,
        },
      ]
      : isFaqRoute
        ? [
          {
            id: "322111",
            title: "चुनाव",
            canonical_url: "/elections",
            amp_url: "/amp/elections",
          },
          // {
          //   id: "322111",
          //   title: `${stateHindi} विधानसभा चुनाव`,
          //   canonical_url: `/elections/${electionPassedCategory}`,
          //   amp_url: "/amp/elections",
          // },
          {
            id: "322112",
            title: `FAQs`,
            canonical_url: `/elections/faqs`,
            amp_url: "/amp/elections",
          },
        ]
        : isConstituencyListPath
          ? [
            {
              id: "322111",
              title: "चुनाव",
              canonical_url: "/elections",
              amp_url: "/amp/elections",
            },
            {
              id: "322111",
              title: `${stateHindi} विधानसभा चुनाव`,
              canonical_url: `/elections/${electionPassedCategory}`,
              amp_url: "/amp/elections",
            },
            {
              id: "322112",
              title: "निर्वाचन क्षेत्र",
              canonical_url: `/elections/${electionPassedCategory}/constituency-list`,
              amp_url: `/amp/elections/${electionPassedCategory}/constituency-list`,
            },
          ]
          : isElectionResultConsistPath
            ? [
              {
                id: "322111",
                title: "चुनाव",
                canonical_url: "/elections",
                amp_url: "/amp/elections",
              },
              {
                id: "322112",
                title: "विधानसभा चुनाव",
                canonical_url: `/elections/assembly-chunav`,
                amp_url: `/elections/assembly-chunav`,
              },
              {
                id: "322111",
                title: `${stateHindi} विधानसभा चुनाव`,
                canonical_url: `/elections/${electionPassedCategory}`,
                amp_url: "/amp/elections",
              },

              {
                id: "322112",
                title: constituencyName + " Election Result",
                canonical_url: `/elections/${electionPassedCategory}/${constituencyName
                  .toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-assembly-constituency-result-${constituencyId}`,
                amp_url: `/elections/${electionPassedCategory}/${constituencyName
                  .toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-assembly-constituency-result-${constituencyId}`,
              },
            ]
            : isCandidateProfilePath
              ? [
                {
                  id: "322111",
                  title: "चुनाव",
                  canonical_url: "/elections",
                  amp_url: "/amp/elections",
                },
                {
                  id: "322111",
                  title: `${stateHindi} चुनाव`,
                  canonical_url: `/elections/${electionPassedCategory}`,
                  amp_url: "/amp/elections",
                },
                {
                  id: "322112",
                  title: "उम्मीदवार",
                  canonical_url: `/elections/${electionPassedCategory}/constituency-list`,
                  amp_url: `/amp/elections/${electionPassedCategory}/constituency-list`,
                },
                {
                  id: "322112",
                  title:
                    candidateName +
                    " " +
                    candidateConstiName +
                    " " +
                    "Election Result",
                  canonical_url: `/elections/${electionPassedCategory}/candidates/${candidateName
                    .toLowerCase()
                    .replace(/[^a-zA-Z ]/g, "")
                    .split(" ")
                    .join("-")}-result-${candidateConstiName
                      ?.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}-${candidateConstituencyId}`,
                  amp_url: `/elections/${electionPassedCategory}/candidates/${candidateName
                    .toLowerCase()
                    .replace(/[^a-zA-Z ]/g, "")
                    .split(" ")
                    .join("-")}-result-${candidateConstiName
                      ?.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}-${candidateConstituencyId}`,
                },
              ]
              : isResultRoute
                ? [
                  {
                    id: "322111",
                    title: "चुनाव",
                    canonical_url: "/elections",
                    amp_url: "/amp/elections",
                  },
                  {
                    id: "322111",
                    title: `${stateHindi} चुनाव`,
                    canonical_url: `/elections/${electionPassedCategory}`,
                    amp_url: "/amp/elections",
                  },
                  {
                    id: "322112",
                    title: "चुनाव परिणाम",
                    canonical_url: `/elections/${electionPassedCategory}/results`,
                    amp_url: `/amp/elections/${electionPassedCategory}/results`,
                  },
                ]
                : isExitPollRoute
                  ? [
                    {
                      id: "322111",
                      title: "चुनाव",
                      canonical_url: "/elections",
                      amp_url: "/amp/elections",
                    },
                    {
                      id: "322111",
                      title: `${stateHindi} चुनाव`,
                      canonical_url: `/elections/${electionPassedCategory}`,
                      amp_url: "/amp/elections",
                    },
                    {
                      id: "322112",
                      title: "एक्जिट पोल",
                      canonical_url: `/elections/${electionPassedCategory}/exit-poll`,
                      amp_url: `/amp/elections/${electionPassedCategory}/exit-poll`,
                    },
                  ]
                  : isKeyCandidatesPath
                    ? [
                      {
                        id: "322111",
                        title: "चुनाव",
                        canonical_url: "/elections",
                        amp_url: "/amp/elections",
                      },
                      {
                        id: "322111",
                        title: `${stateHindi} चुनाव`,
                        canonical_url: `/elections/${electionPassedCategory}`,
                        amp_url: "/amp/elections",
                      },
                      {
                        id: "322112",
                        title: "प्रमुख उम्मीदवार",
                        canonical_url: `/elections/${electionPassedCategory}/key-candidates-list`,
                        amp_url: `/amp/elections/${electionPassedCategory}/key-candidates-list`,
                      },
                    ]
                    : [
                      {
                        id: "322111",
                        title: "चुनाव",
                        canonical_url: "/elections",
                        amp_url: "/amp/elections",
                      },
                      {
                        id: "322111",
                        title: `${stateHindi} चुनाव`,
                        canonical_url: `/elections/${electionPassedCategory}`,
                        amp_url: "/amp/elections",
                      },
                    ];

  useEffect(() => {
    if (
      currentPath === `/elections/faqs` &&
      typeof window.jQuery !== "undefined"
    ) {
      jQuery(document).ready(function () {
        function close_accordion_section() {
          jQuery(".accordion .accordion-section-title").removeClass("active");
          jQuery(".accordion .accordion-section-content")
            .slideUp(300)
            .removeClass("open");
        }
        jQuery(".accordion-section-title").unbind();

        jQuery(".accordion-section-title").click(function (e) {
          // Grab current anchor value
          var currentAttrValue = jQuery(this).attr("href");
          // console.log("currentAttrValue", currentAttrValue);

          if (jQuery(e.target).is(".active")) {
            console.log("1 ----");
            close_accordion_section();
          } else {
            // close_accordion_section();
            console.log("2 ----");

            // Add active class to section title
            jQuery(this).addClass("active");
            // Open up the hidden content panel
            jQuery(".accordion " + currentAttrValue)
              .slideDown(300)
              .addClass("open");
          }
          e.preventDefault();
        });
      });
    }
  }, []);
  console.log("constituencyListData", constituencyListData?.seat_data?.length > 0);
  // scroll down
  useEffect(() => {
    if (constituencyListData?.seat_data?.length > 0) {
      const hash = window.location.hash;
      if (hash === "#election-auto-live-blogs") {
        const scrollToSection = () => {
          const element = document.getElementById("election-auto-live-blogs");
          if (element) {
            // First jump instantly to element (no smooth)
            element.scrollIntoView({ behavior: "smooth", block: "start" });

            // Then do a single smooth correction after short delay
            setTimeout(() => {
              const offset = 80; // adjust this for your sticky header height
              const top =
                element.getBoundingClientRect().top + window.scrollY - offset;
              window.scrollTo({ top, behavior: "smooth" });
            }, 200);
            return true;
          }
          return false;
        };

        if (!scrollToSection()) {
          const interval = setInterval(() => {
            if (scrollToSection()) clearInterval(interval);
          }, 300);
          // setTimeout(() => clearInterval(interval), 5000);
          return () => clearInterval(interval);
        }
      }
    }
  }, []);
  const showCategoryItems = categoryData
  // console.log("electionKeys", electionKeys);
  const [readMore, setReadMore] = useState(true);
  return (
    <article>
      {/* {currentPath === "/elections/faqs" && (
        <HeadTag
          title="Lok Sabha Election 2024 FAQs in Hindi | | MP लोकसभा चुनाव 2024 में पूछे जाने वाले प्रश्न"
          description="Discover the commonly asked questions & answers related to Lok Sabha Elections 2024 (FAQs). हिंदी में जानिए 2024 के सामान्य चुनावों में आमतौर पर पूछे जाने वाले प्रश्नों और उत्तरों (FAQs)."
          keywords="election 2024, lok sabha elections faqs 2024, MP election faqs, lok sabha election faqs, election news, लोकसभा चुनाव 2024, लोकसभा चुनाव 2024 सवाल जवाब"
          canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
        />
      )} */}
      {isMainElectionPath && (
        <HeadTag
          title={categoryNewsListData?.seo_detail?.meta_title}
          description={categoryNewsListData?.seo_detail?.meta_description}
          keywords={categoryNewsListData?.seo_detail?.meta_keyword}
          canonicalUrl={
            process.env.NEXT_PUBLIC_WEBSITE_URL +
            categoryNewsListData?.seo_detail?.canonical_url
          }
          image={categoryNewsListData?.seo_detail?.og_image}
        //  lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
        />
      )}
      {isKeyCandidatesPath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}

      {isCandidateProfilePath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isScheduleElectionPath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isFaqRoute && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isConstituencyListPath && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isElectionResultConsistPath && (
        <>
          <HeadTag
            // title={metaData?.title}
            // description={metaData?.description}
            // keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
            ampUrl={
              process.env.NEXT_PUBLIC_WEBSITE_URL + "/amp" + currentPath
            }
          />
          {/* <WebpageSchema
            // title={metaData?.title}
            // description={metaData?.description}
            // keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          /> */}
        </>
      )}
      {isResultRoute && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      {isExitPollRoute && (
        <>
          <HeadTag
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
            image={categoryNewsListData?.seo_detail?.og_image}
          />
          <WebpageSchema
            title={metaData?.title}
            description={metaData?.description}
            keywords={metaData?.keywords}
            canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentPath}
          />
        </>
      )}
      <GTMScript />

      <Breadcrumb breadcrumbList={BreadcrumbListUpdated} />
      {isFaqRoute && <FAQPageSchema />}
      {<ItemsListSchema data={categoryNewsListData?.content} />}
      {isMainElectionPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
          ]}
        />
      )}
      {isFaqRoute && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            // {
            //   title: `${stateHindi} चुनाव`,
            //   canonical_url:
            //     process.env.NEXT_PUBLIC_WEBSITE_URL +
            //     `/elections/${electionPassedCategory}`,
            // },
            {
              title: `विधानसभा चुनाव से जुड़े सवाल जवाब`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL + `/elections/faqs`,
            },
          ]}
        />
      )}
      {isKeyCandidatesPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "प्रमुख उम्मीदवार",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/key-candidates-list`,
            },
          ]}
        />
      )}
      {/* candidate breadcrumb */}
      {isCandidateProfilePath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "उम्मीदवार",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/key-candidates-list`,
            },
            {
              title:
                candidateName + " " + candidateConstiName + " Election Result",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/candidates/${candidateName
                  ?.toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-result-${candidateConstiName
                    ?.toLowerCase()
                    ?.replace(/[^a-zA-Z ]/g, "")
                    .split(" ")
                    .join("-")}-${candidateConstituencyId}`,
            },
          ]}
        />
      )}
      {isScheduleElectionPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "शेड्यूल",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/schedule`,
            },
          ]}
        />
      )}
      {isConstituencyListPath && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "निर्वाचन क्षेत्र",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/constituency-list`,
            },
          ]}
        />
      )}
      {isElectionResultConsistPath && (
        <BreadcrumbSchema
          breadcrumbList={
            [
              {
                id: "322111",
                title: "चुनाव",
                canonical_url: "/elections",
                amp_url: "/amp/elections",
              },
              {
                id: "322112",
                title: "विधानसभा चुनाव",
                canonical_url: `/elections/assembly-chunav`,
                amp_url: `/elections/assembly-chunav`,
              },
              {
                id: "322111",
                title: `${stateHindi} विधानसभा चुनाव`,
                canonical_url: `/elections/${electionPassedCategory}`,
                amp_url: "/amp/elections",
              },

              {
                id: "322112",
                title: constituencyName + " Election Result",
                canonical_url: `/elections/${electionPassedCategory}/${constituencyName
                  .toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-assembly-constituency-result-${constituencyId}`,
                amp_url: `/elections/${electionPassedCategory}/${constituencyName
                  .toLowerCase()
                  .replace(/[^a-zA-Z ]/g, "")
                  .split(" ")
                  .join("-")}-assembly-constituency-result-${constituencyId}`,
              },
            ]}
        />
      )}
      {isResultRoute && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "चुनाव परिणाम",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/results`,
            },
          ]}
        />
      )}
      {isExitPollRoute && (
        <BreadcrumbSchema
          breadcrumbList={[
            {
              title: "चुनाव",
              canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + "/elections",
            },
            {
              title: `${stateHindi} चुनाव`,
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}`,
            },
            {
              title: "एक्जिट पोल",
              canonical_url:
                process.env.NEXT_PUBLIC_WEBSITE_URL +
                `/elections/${electionPassedCategory}/exit-poll`,
            },
          ]}
        />
      )}

      <div className="mx-4">
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
      </div>
      <ElectionMainTab electionKeys={electionKeys} />
      {/* <Sponsor color="#EE3436" name="चुनाव" electionKeys={electionKeys} /> */}

      <div>
        {/* Left-aligned items */}
        {/* <div className="flex gap-3   flex-row overflow-x-scroll scrollbar-hide mt-2 mx-4 md:mx-4">
          {menuList?.map((item, index) => (
            <a
              className={`${
                currentPath === `/elections/${menuList[index]?.slug}` ||
                (currentPath.includes("-assembly-constituency-result-") &&
                  menuList[index]?.slug ===
                    `${electionPassedCategory}/constituency-list`)
                  ? "bg-primary text-white border-2 border-[#CF4C9B]"
                  : "border-2 text-gray-600 hover:text-primary"
              } px-3 py-1 rounded-xl whitespace-nowrap flex flex-row items-center gap-1 justify-center `}
              href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/elections/${menuList[index]?.slug}`}
              key={item?.slug}
              target={"_self"}
            >
              <div style={{ minWidth: "1rem" }}>
                {[
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif",
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i6.gif",
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i4.gif",
                  "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chunavSeat.svg",
                ].some((icon) => item?.src?.includes(icon)) ? (
                  <img
                    className="h-4 w-4"
                    src={
                      currentPath?.includes("-assembly-constituency-result-") ||
                      currentPath?.includes("constituency-list")
                        ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/constiseat.svg"
                        : item?.src
                    }
                  />
                ) : (
                  <SVG className="h-4 w-4" src={item?.src} />
                )}
              </div>
              <p>{item?.title}</p>
            </a>
          ))}
        </div> */}

        <ElectionsTabs
          menuList={menuList}
          currentPath={currentPath}
          electionPassedCategory={electionPassedCategory}
        />

        <div className="mx-4 md:mx-4 my-2 ">
          {!isExitPollRoute && (
            <ExitPollTally
              masterKey={"assembly_widgets_2026"}
              stateName={stateName}
            />
          )}
          {!isResultRoute && (
            <StateResultTally
              masterKey={"assembly_widgets_2026"}
              stateName={stateName}
            />
          )}
        </div>
        {isFaqRoute && (
          <h1 className="winner-box-header mx-4 my-3 ">
            Assembly Election 2026 FAQs
          </h1>
        )}
        {currentPath === `/elections/faqs` && (
          <>
            <p className={`  mx-4 `}>
              देश के पांच राज्यों, पश्चिम बंगाल, असम, तमिलनाडु, केरल और पुडुचेरी
              में विधानसभा चुनावों का ऐलान हो चुका है. पश्चिम बंगाल में ममता
              बनर्जी फिर रिपीट करेंगी या बीजेपी इस बार करेगी कोई बड़ा खेला. असम
              में हेमंत बिस्वा पर जनता कितना विश्वास करेगी. तमिलनाडु में TVK
              बनेगी बड़ा टर्निंग प्वाइंट या केरल की जनता वाम दलों फिर करेगी
              भरोसा. पुडुचेरी में ऊंट किस करवट बैठेगा...इन सभी सवालों का जवाब 4
              मई 2026 को मिल जाएंगे. हालांकि इससे पहले मतदान से लेकर चुनावी
              प्रक्रिया से जुड़े कई सवाल जनता के मन में हैं जिसका जवाब हम F&Qs
              में दे रहे हैं.
            </p>
            <div
              className={`mt-4 flex flex-col gap-4 text-gray-500 text-md font-extralight mx-2 `}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: `${faqData?.content?.description_short}`,
                }}
              ></p>
            </div>
          </>
        )}

        {isScheduleElectionPath && (
          <div className="mx-4 mt-4">
            {/* <h1 style={{display:"none"}}>{`${stateName} Assembly Election 2024: Schedule`}</h1> */}
            <h1 className="text-primary font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold">
              {stateHindi} विधानसभा चुनाव 2026 शेड्यूल
            </h1>
            <Schedule state={stateHindi} state_en={stateName} />
          </div>
        )}
        {isConstituencyListPath && (
          <div>
            <div className="px-4">
              <h1 className="font-semibold text-2xl mt-4">
                {stateHindi} विधानसभा चुनाव 2026 के सभी निर्वाचन
                क्षेत्रों की पूरी लिस्ट
              </h1>
              {constituencyListContent && (
                <div className="my-2">
                  <div className="my-1 bg-[#FFF] dark:bg-[#000] rounded-[10px]">
                    <p
                      className={`text-[#323232] text-sm text-left relative inline`}
                    >
                      <div
                        className={`${readMore ? "line-clamp-2" : ""}`}
                        dangerouslySetInnerHTML={{ __html: constituencyListContent }}
                      />
                      <span
                        onClick={() => {
                          setReadMore((prev) => !prev);
                        }}
                        className="cursor-pointer inline ml-[5px]  text-primary text-sm"
                      >
                        {readMore ? "और देखें >" : "< कम देखें"}
                      </span>
                    </p>
                  </div>
                </div>
              )}
              {/* <h2 className="text-primary font-bold text-xl md:font-extrabold sm:font-extrabold xs:font-extrabold mt-2">
                Winning Candidate List of {stateName} Assembly Election 2026
              </h2>
              <h2 className="mb-2">
                {`आगामी बिहार विधानसभा चुनाव 2025 में दो चरणों में 6 नवंबर और 11 नवंबर, 2025 को मतदान होगा. मतगणना 14 नवंबर, 2025 को होगी. चुनाव में मुख्य मुकाबला एनडीए और महागठबंधन के बीच होने की उम्मीद है. एनडीए में भाजपा और जेडी(यू) 101-101 सीटों पर चुनाव लड़ने के लिए सहमत हुए हैं, जबकि लोक जनशक्ति पार्टी (रामविलास) और छोटे सहयोगी दल शेष सीटों पर चुनाव लड़ेंगे. विपक्ष की महागठबंधन में राजद, कांग्रेस, वामपंथी दल और अन्य क्षेत्रीय दल मैदान में हैं.`}
              </h2> */}
              {/* <h1 style={{display:"none"}}>LIVE: {stateHindi} विधानसभा विजेता उम्मीदवार </h1> */}
              {/* {electionKeys?.showContentConstituency2020 && (
                <>
                  <h2 className=" font-bold text-lg">
                  {stateHindi} विधानसभा चुनाव {electionKeys?.constListYear}
                  </h2>
                  <h2>
                    {`बिहार विधानसभा चुनाव 2021 में NDA ने 125 सीटें जीतीं थीं. 2015 के मुकाबले NDA को 67 सीटों की बढ़त मिली. हालांकि 2015 में जेडीयू NDA का पार्ट नहीं थी. उसने RJD के साथ मिलकर चुनाव लड़ा था. 2021 में महागठबंधन को 110 सीटें मिली थी. 2015 के मुकाबले महागठबंधन को 68 सीटों का नुकसान हुआ था. 2021 में अन्य को 8 सीटें मिली थीं.`}
                  </h2>
                </>
              )} */}
            </div>
            <RegionalsElectionResultsComponent
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              constituencyListData={constituencyListData}
              stateHindi={stateHindi}
            />
            {/* <iframe
              src={`https://elections.mobiletak.com/regionals/elections/constituency-list-2019/up?base-url=${process.env.NEXT_PUBLIC_WEBSITE_URL}`}
              width={"100%"}
              height={isMobile ? 3300 : 3054}
            /> */}
          </div>
        )}
        {isElectionResultConsistPath && (
          <div className="my-2 mx-2">
            <div className="px-2">
              {/* <h1 style={{display:"none"}}>LIVE {constituencyName} विधानसभा सीट परिणाम or {stateName} Assembly Election Results 2024 |</h1> */}
              <h1 className="text-primary font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold">
                {constHindiName} विधानसभा चुनाव {constListPageMetaYear} (
                {constituencyName} Assembly Election {constListPageMetaYear})
              </h1>
              <h3 className="my-2">
                {stateHindi} की {constHindiName} विधानसभा सीट पर कौन लीड कर रहा
                है? दूसरे नंबर पर कौन है? क्या कोई निर्दलीय बिगाड़ रहा है सियासी
                खेल? सीट का पूरा जोड़-घटाना जानिए बस एक क्लिक में. हर एक राउंड
                में वोटों की गिनती की सबसे तेज और सटीक जानकारी केवल newstak.in
                पर देखें.
              </h3>
            </div>
            <RegionalsConstituencyResultsComponent
              constHindiName={constHindiName}
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              constituencyTempListData={constituencyListData}
              candidateData={candidateData}
              constituencyDetailData={constituencyDetailData}
              constituencyName={constituencyName}
              stateName={stateName}
              latestCandidates={latestCandidates}
            />
            {ConstituencyliveBlogData && (
              <LiveBlogCard constituencyDetailData={ConstituencyliveBlogData} constituencyName={constituencyName} />
            )}
            <ConstituencyLinks
              constituencyListData={constituencyListData}
              customTitle={`${stateHindi} विधानसभा निर्वाचन क्षेत्र`}
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
            />
            {/* <iframe
              src={`https://elections.mobiletak.com/regionals/elections/constituency-list-2019/${constituencyId}/up?state-id=S24`}
              width={"100%"}
              height={900}
            /> */}
          </div>
        )}
        {/* mtf-1 code  */}

        {isResultRoute && (
          <div className=" mx-3">
            {/* <h1
              style={{ display: "none" }}
            >{`${stateHindi} विधानसभा चुनाव परिणाम ${electionKeys?.resultYear}`}</h1> */}
            <div className="mx-2 my-2">
              <div>
                <h1
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#000",
                  }}
                >
                  {stateHindi} विधानसभा चुनाव परिणाम 2026
                </h1>
              </div>
              <div
                className="my-2"
                dangerouslySetInnerHTML={{
                  __html: electionKeys?.resultYear == 2021 ? oldDesc : newDesc,
                }}
              />
              <h2 style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#000",
              }}> {stateHindi} विधानसभा चुनाव परिणाम {electionKeys?.resultYear}</h2>
              {resultData?.partyData?.length > 0 && (
                <div class="table_cont" style={{ marginTop: "15px" }}>
                  <div class="tbbody">
                    <div
                      class="tbhead"
                      style={{
                        backgroundColor: "#D71920",
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "10px",
                        borderTopLeftRadius: "4px",
                        borderTopRightRadius: "4px",
                      }}
                    >
                      <div style={{ marginLeft: "5%" }}>
                        <p
                          style={{
                            fontWeight: 700,
                            fontSize: "1.25rem",
                            color: "#FFF",
                          }}
                        >
                          Party
                        </p>
                      </div>
                      <div style={{ marginRight: "5%" }}>
                        <p
                          style={{
                            fontWeight: 700,
                            fontSize: "1.25rem",
                            color: "#FFF",
                          }}
                        >
                          Total
                        </p>
                      </div>
                    </div>
                    {resultData.partyData &&
                      resultData.partyData.length > 0 &&
                      resultData.partyData.map((item, index) => {
                        return (
                          <div
                            key={index}
                            class="tbhead"
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "#EEF3F7" : "#FBFBFB",
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "10px",
                              borderTopLeftRadius: "4px",
                              borderTopRightRadius: "4px",
                            }}
                          >
                            <div style={{ marginLeft: "5%" }}>
                              <p style={{ color: "#777777" }}>
                                {item.partyName}
                              </p>
                            </div>
                            <div style={{ marginRight: "5%" }}>
                              <p style={{ fontWeight: 700, color: "#000" }}>
                                {item.partySeat}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {isExitPollRoute && (
          <>
            <h1
              className="mx-4 my-3  font-bold text-2xl mb:font-extrabold sm:font-extrabold xs:font-extrabold"
              style={{ fontSize: "22px", fontWeight: 700 }}
            >
              {stateHindi} विधानसभा चुनाव {electionKeys?.exitDataYear} एग्जिट
              पोल
            </h1>
            {/* old data  */}
            {electionKeys?.exitDataYear == 2021 &&
              <div className="mx-4 md:mx-4  "><ExitPollCard exitPollData={exitPollData} halfwayMark={halfwayMark} /></div>}
            {electionKeys?.showExitPollTallyOnPage && (
              <div className="mx-4 md:mx-4  ">
                <iframe
                  title="vidhan sabha exit poll"
                  src={
                    masterConfig["assembly_widgets_2026"]?.showTallyURL +
                    `&state_name=${stateName?.split(" ")?.join("-")?.toLowerCase()}`
                  }
                  className={`min-h-[${masterConfig["assembly_widgets_2026"]?.exitPollHeight}px] w-full scrollbar-none`}
                  height={masterConfig["assembly_widgets_2026"]?.exitPollHeight}
                />
              </div>
            )}
          </>
        )}

        {isKeyCandidatesPath && (
          <div className="mx-4">
            <StateKeyCandidate
              stateHindi={stateHindi}
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
            />
          </div>
        )}

        {/* candidate profile page */}
        {isCandidateProfilePath && (
          <div className="mx-4">
            <CandidateProfile
              electionPassedCategory={electionPassedCategory}
              masterKey={masterKey}
              candidateProfileData={candidateProfileData}
              candidateList={candidateList}
            />
            {ConstituencyliveBlogData && (
              <LiveBlogCard constituencyDetailData={ConstituencyliveBlogData} constituencyName={constituencyName} />
            )}
          </div>
        )}
      </div>

      {
        <section
          className="mx-5 md:mx-5 md:px-1 "
          id="election-auto-live-blogs"
        >
          {/* <AdSlot300x250
            divId="div-gpt-ad-1659434604998-0"
            minWidth="300px"
            minHeight="250px"
          /> */}
          {categoryNewsListData?.content?.length >= 3 && (
            <div className="mx-3 md:mx-3 md:py-2">
              <AdSlot728x90
                divId="div-gpt-ad-1707804176041-2"
                minWidth="720px"
                minHeight="90px"
              />
            </div>
          )}

          {/* <ContentGrid content={categoryNewsListData?.content?.slice(0, 6)} heading="" /> */}
          {size.width < 900 ? (
            <div className="my-2">
              <List1
                title={showCategoryItems?.length > 0 ? stateHindi + " विधानसभा चुनाव" : ''}
                newsListData={showCategoryItems}
                isLCP={true}
                haveH1={false}
                showAds={true}
                election={true}
                scrolled={true}
              />
              {/* <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={mobileInsightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div> */}
            </div>
          ) : (
            <div className="my-2" >
              <List2
                title={showCategoryItems?.length > 0 ? stateHindi + " विधानसभा चुनाव" : ''}
                newsListData={showCategoryItems}
                isLCP={true}
                showAds={false}
                haveH1={false}
                scrolled={true}
              />
              {/* <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={insightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div> */}
            </div>
          )}
          {
            categoryData?.length >= 12 &&
            hasMore && (
              <div className="justify-items-center">
                <div
                  onClick={() => {
                    if (loadingSpinner || !hasMore) return;
                    setCurrentPage(prev => prev + 1);
                  }}
                  className={`bg-primary
          flex align-middle py-[10px] my-4 px-4 rounded-full 
          justify-center items-center text-white 
          cursor-pointer m-auto w-fit`}
                >
                  {loadingSpinner ? "लोड हो रहा..." : "और देखें "}
                </div>
              </div>
            )}

          {categoryNewsListData?.content?.length === 0 &&
            categoryData?.length === 0 && <NoData message="No Data Found" />}

          {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
        </section>
      }
      <div className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />{" "}
      </div>

      {/* static content */}
      {staticContent && (
        <div className="my-8 mx-2">
          <h2 className="flex text-xl font-semibold mx-2">
            <span className="w-2 h-[auto] bg-primary inline-block mr-2"></span>
            {stateHindi} 2026 विधानसभा चुनाव
          </h2>

          <div className="my-1 mx-2 bg-[#FFF] dark:bg-[#000] rounded-[10px]">
            <p className={`text-[#323232] text-sm text-left relative inline`}>
              <div
                className={`${readMore ? "line-clamp-2" : ""}`}
                dangerouslySetInnerHTML={{ __html: staticContent }}
              />
              <span
                onClick={() => {
                  setReadMore((prev) => !prev);
                }}
                className="cursor-pointer inline ml-[5px]  text-primary text-sm"
              >
                {readMore ? "और देखें >" : "< कम देखें"}
              </span>
            </p>
          </div>
        </div>
      )}
      {electionKeys?.autoLiveBlog && (
        <div className="mx-2">
          <StatesConstituencyLiveResult
            masterKey={electionKeys}
          />
        </div>
      )}
    </article>
  );
};

export default Index;
